import { apiClient } from '../api-client'
import { ActivityLog, PaginatedResponse } from '@/types'

// Activity Log API
export const activityApi = {
  getActivities: (filters?: any, page = 1, limit = 20): Promise<PaginatedResponse<ActivityLog>> =>
    apiClient.get('/activity', { params: { ...filters, page, limit } }),

  getEntityActivities: (entityType: string, entityId: string): Promise<ActivityLog[]> =>
    apiClient.get(`/activity/${entityType}/${entityId}`),
}